import type { Task } from "@src/domain/pascos/entities/task.entity";
import type { TaskDTO, TaskListItemDTO } from "../dto";

/**
 * Task DTO Mapper
 * Maps between Task domain entities and TaskDTOs
 */
export class TaskDtoMapper {
    /**
     * Convert Task entity to TaskDTO
     */
    static toDTO(task: Task): TaskDTO {
        return {
            id: task.taskId,
            status: task.status,
            pascoId: task.pascoId,
            errorMessage: task.errorMessage,
            attemptCount: task.attemptCount,
            createdAt: task.createdAt.toISOString(),
            updatedAt: task.updatedAt.toISOString(),
        };
    }

    /**
     * Convert Task entity to TaskListItemDTO
     */
    static toListItemDTO(task: Task): TaskListItemDTO {
        return {
            id: task.taskId,
            status: task.status,
            pascoId: task.pascoId,
            errorMessage: task.errorMessage,
            attemptCount: task.attemptCount,
            createdAt: task.createdAt.toISOString(),
            updatedAt: task.updatedAt.toISOString(),
        };
    }

    /**
     * Convert array of Task entities to array of TaskListItemDTOs
     */
    static toListItemDTOArray(tasks: Task[]): TaskListItemDTO[] {
        return tasks.map(task => this.toListItemDTO(task));
    }

    /**
     * Convert array of Task entities to array of TaskDTOs
     */
    static toDTOArray(tasks: Task[]): TaskDTO[] {
        return tasks.map(task => this.toDTO(task));
    }
}
